module.exports = __webpack_public_path__ + "img/symphony_599_elephant.3174f3a5.jpg";